import { xingConnect } from '@xingternal/frame-data-provider';
import { PersonalBar as PersonalBarComponent } from './PersonalBar';
import { personalBarSelector } from './PersonalBar.selectors';
export const PersonalBar = xingConnect(personalBarSelector)(PersonalBarComponent);
//# sourceMappingURL=PersonalBar.container.js.map